import { useTranslation } from 'react-i18next';

export function InfoSection() {
  const { t } = useTranslation();

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Support Hours Card */}
          <div className="bg-gray-900 rounded-2xl border border-gray-700 p-8">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-yellow-400/10 rounded-full flex-shrink-0">
                <i className="ri-time-line text-2xl text-yellow-400"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-white mb-4">{t('contact.info.hours.title')}</h3>
                <div className="space-y-2 text-gray-300">
                  <p>{t('contact.info.hours.weekdays')}</p>
                  <p>{t('contact.info.hours.saturday')}</p>
                  <p>{t('contact.info.hours.sunday')}</p>
                </div>
                {/* <p className="text-sm text-yellow-400 mt-4 font-medium">{t('contact.info.hours.note')}</p> */}
              </div>
            </div>
          </div>

          {/* Location Card */}
          <div className="bg-gray-900 rounded-2xl border border-gray-700 p-8">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-yellow-400/10 rounded-full flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-yellow-400"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-white mb-4">{t('contact.info.location.title')}</h3>
                <div className="space-y-2 text-gray-300">
                  <p className="font-medium">{t('contact.info.location.city')}</p>
                  <p>{t('contact.info.location.serving')}</p>
                </div>
                <p className="text-sm text-yellow-400 mt-4 font-medium">{t('contact.info.location.note')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
